import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "surveyContent" }
const _hoisted_2 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_3 = { class: "wp1200 survey" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_survey absolute" }, null, -1)
const _hoisted_5 = { class: "surveyCard" }
const _hoisted_6 = { class: "content" }
const _hoisted_7 = {
  key: 0,
  class: "progress"
}
const _hoisted_8 = { class: "text" }
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = { class: "none" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_calendar" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_arrow-R" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.surveys.length === 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.$t("global.no_data")), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.surveys, (survey, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "boxMessage",
          key: index
        }, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h4", null, _toDisplayString(survey.browser_title || survey.long_project_name || survey.name), 1),
              (survey.progress > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_ProgressBar, {
                      value: survey.progress
                    }, null, 8, ["value"]),
                    _createElementVNode("span", _hoisted_8, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t("survey.you_solved")) + " " + _toDisplayString(survey.progress) + "% " + _toDisplayString(_ctx.$t("survey.of_this_survey")), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", null, [
                  _createElementVNode("ul", _hoisted_10, [
                    _createElementVNode("li", null, [
                      _hoisted_11,
                      _createElementVNode("span", null, _toDisplayString(_ctx.$moment(survey.start_date).format("DD.MM.YYYY")) + " - " + _toDisplayString(_ctx.$moment(survey.end_date).format("DD.MM.YYYY")), 1)
                    ])
                  ])
                ])
              ]),
              _hoisted_12,
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.startSurvey(index)),
                class: "surveyNextButton"
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t("survey.start")) + " ", 1),
                _hoisted_14
              ], 8, _hoisted_13)
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}